import { NgFor } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';

import { Subject } from 'rxjs';

import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { SVGIcon, xIcon } from "@progress/kendo-svg-icons";

import { QueryPanelConnectorService} from 'src/app/modules/fwcore/services';
import { TreeViewFilterDataItem } from 'src/app/modules/fwcore/models';

@Component({
  selector: 'criteria-summary-box',
  standalone: true,
  styleUrls: ['./criteria-summary-box.component.scss'],
  templateUrl: './criteria-summary-box.component.html',
  imports: [ButtonsModule, NgFor]
})

export class CriteriaSummaryBox {
  /*-------------------------- Internal properties  ------------------*/
  protected destroy$ = new Subject();
  protected selectedFilters: TreeViewFilterDataItem[] = [];
  protected xicon: SVGIcon = xIcon;
  protected subscription: any;

  /*-------------------------- Input / Outputs --------------------------------*/
  @Output() itemDeleted: EventEmitter<TreeViewFilterDataItem> = new EventEmitter();

  /*-------------------------- Constructor  --------------------------*/
  constructor (
    protected connectorService: QueryPanelConnectorService,
    protected cdr: ChangeDetectorRef) {
    this.subscription = this.connectorService.onMessage().subscribe(message => {
      if (message) {
        switch (message.type) {
          case "add":
            if (message.item) { this.addItem(message.item); }
            break;
          case "clear":
            this.selectedFilters = [];
            break;
          case "delete":
            if (message.item) { this.removeItem(message.item); }
            break;
          case "load":
            this.connectorService.isLoaded("_");
            break;
        }
      }
    });
  }

  /*-------------------------- ng --------------------------*/
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  /*-------------------------- Public methods --------------------------*/
  public addItem(addedItem: TreeViewFilterDataItem) {
    if (addedItem) {
      this.selectedFilters = [...this.selectedFilters, addedItem];
    }
  }

  public removeItem(removedItem: TreeViewFilterDataItem) {
    if (removedItem) {
      this.selectedFilters = this.selectedFilters.filter((i) =>
        (i.id !== removedItem.id)
        || (i.controlName !== removedItem.controlName));
    }
  }

  public trackFilters(i: number) {
    return i;
  }

  /*-------------------------- Event handlers --------------------------*/
  onButtonClick(e: PointerEvent, id: string) {
    if (id) {
      let items = this.selectedFilters.filter((i) => i.id == id);
      if (items.length) {
        this.selectedFilters = this.selectedFilters.filter((i) => i.id !== id);
        //this.itemDeleted.emit(result[0]);
        this.connectorService.removeItem(items[0], false);
      }
    }
  }
}
